import * as React from 'react'

const Header = () => {
    return (
        <header class="header">

        </header>
    )
}

export default Header